import * as React from 'react';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { useHistory } from 'react-router';


const ProfileImage = ({ idClinica, imagenActual }) => {
    const [image, setImage] = React.useState(null);
    const history = useHistory();
    const updateImage = async () => {
        var dataFile = new FormData();
        dataFile.append("imagen", image);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}clinica/${idClinica}/actualizar_imagen`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFile
        }).then(response => {
            return response.json();
        })
            .then(data => {
                console.log(data);
                history.go(0);
            })
            .catch((error) => {
                console.log(error);
                alert("Ha ocurrido un error subiendo la imagen");
            });
    }

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div>
                        <div>
                            {imagenActual != null ?
                                <img alt="logo"
                                    src={process.env.REACT_APP_PUBLIC_URL + "clinica/" + idClinica + "/logo/" + sessionStorage.getItem('token')}
                                    style={{ width: '15%' }} />
                                :
                                <b>Aun no ha subido una imagen</b>
                            }
                        </div>

                        <input accept="image/*" id="factibilityFile" name="factibilityFile" type="file" onChange={(e) => { setImage(e.target.files[0]) }} />
                        <br /><br />
                        <Button
                            style={{ marginTop: 20 }}
                            color="primary"
                            size='sm'
                            onClick={() => {
                                updateImage()
                            }}
                        >
                            Actualizar Imagen
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </Col>

    )
};

export default ProfileImage;